/**
 * This object representates a Invitation to a study.  In this object information about the invitation
 * taken together and saved. These informations are only the basic.
 */
export class Invite {
    private id: String;
    private model_id: Number;
    private expires_at: Number;
    private invitation_id: String;

    /**
     * Constructor of the object Invitation
     * @param id
     * @param model_id
     */
    constructor (id: String, model_id?: Number, expires_at?: Number) {
        this.id = id;
        if (model_id) { this.model_id = model_id; }
        if (expires_at) { this.expires_at = expires_at; }
    }

    /**
    * This function sets the id
    * @param id id of study
    */
    public setId(id: String): void {
        this.id = id;
    }

    /**
    * This function returns the id
    * @return id of study
    */
    public getId(): String {
        return this.id;
    }

    /**
     * This function sets the model_id
     * @param model_id
     */
    public setModelId(model_id: Number): void {
        this.model_id = model_id;
    }

    /**
     * This function returns the model_id
     * @return model_id of invitation
     */
    public getModelId(): Number {
        return this.model_id;
    }

    /**
     * This function sets the expires_at
     * @param expires_at
     */
    public setExpiresAt(expires_at: Number): void {
        this.expires_at = expires_at;
    }

    /**
     * This function gets the expires_at
     * @return expires_at of invitation
     */
    public getExpiresAt(): Number {
        return this.expires_at;
    }

    public setInvitationId(id: String) {
        this.invitation_id = id;
    }

    public getInvitationId() {
        return this.invitation_id;
    }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/invite.ts